// extracted by mini-css-extract-plugin
export default {"control":"control_control__z0ak9","addIcon":"control_addIcon__Uu-M8"};